import { Radio } from 'antd';

export default Radio;
